import { ViewModel,View, ObservableArray } from "binder"
import  { WarehouseKeepingDetailView } from "./warehouseKeepingDetail-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WarehouseKeepingListViewModel } from "../warehouseKeepingList/warehouseKeepingList-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";
import { WarehouseKeepingPartDetailViewModel } from "../warehouseKeepingPartDetail/warehouseKeepingPartDetail-viewModel";
import { downloadFile } from "src/uicomponents/components/utilities";
import { CreateWarehouseKeepingPartViewModel } from "../createWarehouseKeepingPart/createWarehouseKeepingPart-viewModel";

export class WarehouseKeepingDetailViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: WarehouseKeepingListViewModel, id: string) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.warehouseKeepingId = id;
        this.load();

        this.keepingParts = ObservableArray.create<KeepingPart>();
    }
    closePopup(resultCode?: string) {
        this._typedParent.isShowingPopup = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new WarehouseKeepingDetailView();
    }
    public getTypeId(): string {
        return "VM-877EA5E6-FAD1-490C-B0C7-8A0A12AE6348"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseKeepingId(v: string) { this._warehouseKeepingId = v; } public get warehouseKeepingId(): string { return this._warehouseKeepingId;} private _warehouseKeepingId: string;
    public set createTime(v: moment.Moment) { this._createTime = v; } public get createTime(): moment.Moment { return this._createTime;} private _createTime: moment.Moment;
    public set endTime(v: moment.Moment) { this._endTime = v; } public get endTime(): moment.Moment { return this._endTime;} private _endTime: moment.Moment;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set keepingParts(v: ObservableArray<KeepingPart>) { this._keepingParts = v; } public get keepingParts(): ObservableArray<KeepingPart> { return this._keepingParts;} private _keepingParts: ObservableArray<KeepingPart>;
    
    private _typedParent : WarehouseKeepingListViewModel;

    async load(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseKeepingServices/LoadWarehouseKeepingParts',{
                KeepingId:this.warehouseKeepingId,
            });
            this.createTime = moment.utc(result.StartTime);
            this.endTime = result.EndTime==null ? null : moment.utc(result.EndTime);
            this.warehouseId = result.WarehouseId;
            this.warehouseName = result.WarehouseName;
            this.keepingParts.update(...result.Parts.map((q,i)=>{
                let r = new KeepingPart(this);
                r.index = i+1;
                r.keepingPartId = q.Id;
                r.createTime = moment.utc(q.From);
                r.endTime = q.Until==null ? null : moment.utc(q.Until);
                r.isFinalized = q.Until==null ? false : true;

                r.orderId = q.OrderId;
                r.orderNo = q.OrderNo;
                r.receiptId = q.ReceiptId;
                r.receiptNo = q.ReceiptNo;
                r.hasProblematicEntry = q.HasProblematicEntry;
                r.hasAccess = result.HasAccessWarehouseKeeping;
                r.countingFinishedTime = q.CountingFinishedTime == null ? null : moment.utc(q.CountingFinishedTime);
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async addProducts() {
        let newForm = new CreateWarehouseKeepingPartViewModel(this, this.warehouseKeepingId, this.warehouseId);
        let result = await this._typedParent.showPopup(newForm,false);
        if(result=='done'){
            this.load();
        }
    }

    async showDetail(id:string) {
        let keepingDetail = new WarehouseKeepingPartDetailViewModel(this, this.warehouseKeepingId, id);
        let result = await this._typedParent.showPopup(keepingDetail,false);
        if(result=='done'){
            this.load();
        }
    }
    async exportExcel(id:string) {
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseKeepingServices/ExportPartProducts',{
                KeepingId: this.warehouseKeepingId,
                PartId: id
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }

            downloadFile(result.ExcelFile,'بسته انبار گردانی.xlsx');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async deletePart(id:string) {
        try {
            let confirmation ='';
            confirmation = await this.messageBoxWarningYesNo('آیا دسته محصولات حذف شود؟','حذف دسته انبارگردانی');
            if(confirmation=='no'){
                return;
            }
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseKeepingServices/DeleteWarehouseKeepingPart',{
                KeepingId: this.warehouseKeepingId,
                PartId: id
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            await this.messageBoxConfirmSuccess('دسته محصولات با موفقیت حذف شد.','عملیات موفق');
            this.load();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async finalize() {
        try {
            let confirmation ='';
            confirmation = await this.messageBoxWarningYesNo('آیا با پایان انبارگردانی مطمئنید؟','پایان انبارگردانی');
            if(confirmation=='no'){
                return;
            }
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseKeepingServices/FinalizeWarehouseKeeping',{
                KeepingId: this.warehouseKeepingId
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            await this.messageBoxConfirmSuccess('انبارگردانی با موفقیت پایان یافت.','عملیات موفق');
            this.load();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async remaindReport() {
        try {
            this.isLoading = true;
            let result =await ServerConnection.callServer('/Complex/WarehouseKeepingServices/GetRemainingProductsToKeep',{
                KeepingId: this.warehouseKeepingId
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            downloadFile(result.Data, `Remaining Products To Keep.xlsx`);
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }
}

export class KeepingPart extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:WarehouseKeepingDetailViewModel) {
        super(parent);
        this._typedParent = parent;   
    }
    private _typedParent:WarehouseKeepingDetailViewModel;

    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set keepingPartId(v: string) { this._keepingPartId = v; } public get keepingPartId(): string { return this._keepingPartId;} private _keepingPartId: string;
    public set createTime(v: moment.Moment) { this._createTime = v; } public get createTime(): moment.Moment { return this._createTime;} private _createTime: moment.Moment;
    public set endTime(v: moment.Moment) { this._endTime = v; } public get endTime(): moment.Moment { return this._endTime;} private _endTime: moment.Moment;
    public set countingFinishedTime(v: moment.Moment) { this._countingFinishedTime = v; } public get countingFinishedTime(): moment.Moment { return this._countingFinishedTime;} private _countingFinishedTime: moment.Moment;
    
    public set isFinalized(v: boolean) { this._isFinalized = v; } public get isFinalized(): boolean { return this._isFinalized;} private _isFinalized: boolean;
    public set orderId(v: string) { this._orderId = v; } public get orderId(): string { return this._orderId;} private _orderId: string;
    public set orderNo(v: string) { this._orderNo = v; } public get orderNo(): string { return this._orderNo;} private _orderNo: string;
    public set receiptId(v: string) { this._receiptId = v; } public get receiptId(): string { return this._receiptId;} private _receiptId: string;
    public set receiptNo(v: string) { this._receiptNo = v; } public get receiptNo(): string { return this._receiptNo;} private _receiptNo: string;
    public set hasProblematicEntry(v: boolean) { this._hasProblematicEntry = v; } public get hasProblematicEntry(): boolean { return this._hasProblematicEntry;} private _hasProblematicEntry: boolean;
    public set hasAccess(v: boolean) { this._hasAccess = v; } public get hasAccess(): boolean { return this._hasAccess;} private _hasAccess: boolean;
    
    async showDetail(){
        this._typedParent.showDetail(this.keepingPartId);
    }  

    async delete(){
        this._typedParent.deletePart(this.keepingPartId);
    }  
    async exportExcel(){
        this._typedParent.exportExcel(this.keepingPartId);
    }
}
